<template>
  <div class="my-edit-bookshelf-area">
    <div class="my-shelfEdit">
      <div class="bookshelft-header-div"><span class="bookshelf-header">我的图书馆</span><span style="margin-right:4px">></span><span class="bookshelf-header">编辑图书馆</span></div>
      <setEditLib ref="setLib"></setEditLib>
      <libTransfer @getSeaveButton="getSeaveButton"></libTransfer>
      <shelfLibButton :showSaveButton="showSaveButton" @saveDataCon="saveDataCon" :setType="setType"></shelfLibButton>
    </div>
  </div>
</template>

<script>
import setEditLib from '@components/editBookShlefLibrary/setEditLib'
import libTransfer from '@components/editBookShlefLibrary/libTransfer'
import shelfLibButton from '@components/editBookShlefLibrary/shelfLibButton'
import interfaceLib from '@api/bookLib'
import { setEncryption, sliceStrPicUrl } from '@/utils'

export default {
  name: 'libEdit',
  data() {
    return {
      setType: '图书馆',
      showSaveButton: true
    }
  },
  components: {
    setEditLib,
    libTransfer,
    shelfLibButton
  },
  methods: {
    getSeaveButton(item) {
      this.showSaveButton = item
      console.log(this.showSaveButton)
    },
    saveDataCon(type) {
      if (this.$store.state.config.bookLibObj.title == '') {
        this.$message({
          message: '必须填写图书馆名称',
          type: 'error'
        })
        return false
      }
      if (this.$store.state.config.bookLibObj.selPoster == 1 && !this.$store.state.config.bookLibObj.customTit) {
        this.$message({
          message: '请设置风格名称',
          type: 'error'
        })
        return
      }

      const questionaireCheckReason = this.$refs.setLib.check().questionaireCheckReason
      if (!questionaireCheckReason) {
        this.$message({ message: '请完成读者在线问卷设置', type: 'error' })
        return
      }

      let logo = null
      if (this.$refs.setLib.logoLib == 0) {
        logo = 'logo.png'
      } else if (this.$refs.setLib.logoLib == 1) {
        let libLogo = this.$store.state.config.bookLibLogo.logo
        if (libLogo) {
          logo = libLogo.substring(libLogo.indexOf('attach/'))
        }
      }
      const payload = this.$store.state.config.bookLibObj.selPoster == 1 ? this.$store.state.config.bookLibObj.cusImg : 'poster.png'
      const posterPic = sliceStrPicUrl(payload)
      let thumbnail = this.$store.state.config.bookLibObj.thumbnail == 'default' ? '' : this.$store.state.config.bookLibObj.thumbnail
      const questionaireData = this.$refs.setLib.getData().questionaireData
      let params = {
        id: this.libId,
        style: this.$store.state.config.bookLibObj.style,
        openMode: this.$store.state.config.bookLibObj.openMode,
        name: this.$store.state.config.bookLibObj.title,
        shareTitle: this.$store.state.config.bookLibObj.shareTitle,
        description: this.$store.state.config.bookLibObj.shareDesc,
        thumbnail: thumbnail.indexOf('data:image') > -1 ? thumbnail : '',
        itemIds: this.itemIds,
        logo: logo,
        url: this.$refs.setLib.urlLib,
        linkJump: this.$refs.setLib.linkJump,
        poster: this.$store.state.config.bookLibObj.isPoster,
        posterStyle: this.$store.state.config.bookLibObj.selPoster,
        posterTitle: this.$store.state.config.bookLibObj.selPoster == 0 ? '' : this.$store.state.config.bookLibObj.customTit,
        // posterPic: this.$store.state.config.bookLibObj.selPoster == 1 ? this.$store.state.config.bookLibObj.cusImg : 'poster.png',
        posterPic: posterPic,
        posterQrCodeShow: this.posterLib.posterQrCodeShow,
        posterNameShow: this.posterLib.posterNameShow,
        posterName: this.posterLib.posterName,
        posterTextShow: this.posterLib.posterTextShow,
        posterPromptText: this.posterLib.posterPromptText,
        posterCover: this.posterLib.posterCover.toString(),
        switchGroup: JSON.stringify(this.$store.state.config.bookLibObj.displayOrNot),
        language: this.$store.state.config.bookLibObj.language,
        ...questionaireData
      }
      interfaceLib.bookLibEdit(params).then((res) => {
        if (res.status == 200 && res.data.code == 0 && res.data.data) {
          this.$store.commit('config/UPDATE_BOOKLIBTITLE_MESSAGE', '')
          this.$store.commit('config/UPDATE_BOOKLIBTITLE_TITLE', '')
          this.$store.commit('config/UPDATE_BOOKLIBTITLE_DESC', '')
          this.$store.commit('config/UPDATE_BOOKLIBTHUMBNAIL', '')
          this.$store.commit('config/UPDATE_BOOKSLIB_IDS', [])
          if (type == 'goDetail') {
            const encryption_id = setEncryption(this.libId)
            this.$router.push({ path: '/bookLibdetail', query: { id: encryption_id, openMode: this.$store.state.config.bookLibObj.openMode } })
            // let routeUrl = this.$router.resolve({
            //   path: '/bookLibdetail',
            //   query: { id: this.libId }
            // })
            // window.open(routeUrl.href, '_blank')
          } else if (type == 'goList') {
            let componentManager = 'Published'
            this.$store.commit('manage/UPDATE_COMPONENTMANAGER', componentManager)
          }
        }
      })
    }
  },
  computed: {
    itemIds() {
      return this.$store.state.config.bookLibObj.ids.toString()
    },
    libId() {
      return window.sessionStorage.getItem('libId')
    },
    posterLib() {
      return this.$store.state.config.poster.lib
    }
  },
  beforeCreate() {
    // document.querySelector('body').setAttribute('style', 'overflow:auto')
  },
  destroyed() {
    // document.querySelector('body').setAttribute('style', 'overflow:hidden')
  }
}
</script>

<style scoped lang="scss">
.my-edit-bookshelf-area {
  position: relative;
  width: 100%;
  height: calc(100vh - 120px);
  overflow-y: auto;
  .my-shelfEdit {
    width: 1000px;
    margin: 0 auto;
    margin-left: 50px;
    position: relative;
    .bookshelft-header-div {
      padding: 8px 0;
      // padding-left: 5%;
      .bookshelf-header {
        font-size: 17px;
        margin-right: 6px;
        color: #000;
        font-weight: 400;
      }
      .num-info {
        font-size: 16px;
        display: inline-block;
      }
    }
  }
  /deep/ .shelfEditButton {
    position: fixed;
    bottom: 0;
    height: 80px;
    width: 1000px;
    background-color: #fff;
    text-align: center;
    padding: 20px 0;
    border-top: 1px solid #ececec;
    z-index: 999;
    .goDetail {
      width: 180px;
      background: #df5813;
      color: #fff;
      font-size: 14px;
    }
    .goList {
      border: 1px solid #df5813;
      color: #df5813;
      font-size: 14px;
    }
  }
}
</style>
